<template>
  <div>
    <nav v-if="true" class="navbar-default navbar-static-side">
      <el-menu
        class="el-menu-vertical-demo"
        @select="gotoUrl"
        default-active="landingPage"
      >
        <div v-for="menu in functionList" :key="menu.id">
          <el-submenu :index="menu.id + ''" v-if="menu.children">
            <template slot="title">
              <i class="el-icon-menu"></i>
              <span>{{ menu.name }}</span>
            </template>
            <template v-for="menu2item in menu.children">
              <el-menu-item
                :index="menu2item.webInfo"
                v-if="!menu2item.children"
                :key="menu2item.id"
              >
                {{ menu2item.name }}
              </el-menu-item>
              <el-submenu
                :index="menu2item.id + ''"
                v-else
                :key="menu2item.id"
              >
                <template slot="title">
                  <span>{{ menu2item.name }}</span>
                </template>
                <el-menu-item
                  :index="menu3item.webInfo"
                  v-for="menu3item in menu2item.children"
                  :key="menu3item.id"
                >
                  {{ menu3item.name }}
                </el-menu-item>
              </el-submenu>
            </template>
          </el-submenu>
          <el-menu-item :index="menu.webInfo" v-if="!menu.children">
            <i class="el-icon-menu"></i>
            <span slot="title">{{ menu.name }}</span>
          </el-menu-item>
        </div>
      </el-menu>
    </nav>
  </div>
</template>
<script>
import broadcast from "../../lib/broadcast.js";

export default {
  name: "navigationController",
  data() {
    return {
      activeName: "",
      liIndex: null,
      ctrlActive: false,
      styleHeight: {
        height: "auto !important",
      },
      positionIndex: [],
    };
  },
  methods: {
    gotoUrl(webInfo, indexArr) {
      this.$router.push({ path: webInfo });
      this.emitIndex();
    },
    showList(funcName, liIndex) {
      if (funcName === this.activeName) {
        this.activeName = undefined;
        this.liIndex = undefined;
      } else {
        this.activeName = funcName;
        this.liIndex = liIndex;
      }
    },
    emitIndex() {
      broadcast.$emit("getIndex", this.positionIndex);
    },
  },
  computed: {
    functionList() {
      return this.$store.state.userInfo.systemFuncs;
    },
  },
  mounted: function () {
    var that = this;
  },
};
</script>
